import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { FormControl, UntypedFormControl } from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DOCUMENT_TAG} from '../../../models/constants/document-tag.model';
import {FileManagerService} from '../../file-manager/file-manager.service';
@Component({
  selector: 'app-change-image-date-dialog',
  templateUrl: './change-image-date-dialog.component.html',
  styleUrls: ['./change-image-date-dialog.component.scss']
})
export class ChangeImageDateDialogComponent implements OnInit{
  isLoading: any;
  message: any;
  dateReceived: any;
  isConfirmDisabled: any;
  private isWindowsEnvironment: boolean;
  imageDate: string;
  documentIds: string[] = [];
/*
  isErrorFindingTwainDrivers: any;
  twainsources: any;
  selectedTwain: any;
*/
  constructor(
    public dialogRef: MatDialogRef<ChangeImageDateDialogComponent>,
    private fileManagerService: FileManagerService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.documentIds.push(this.data.documentId);
    this.documentIds.push(this.data.ParentDocumentID);
    this.message = 'Change Image Date';
    this.isWindowsEnvironment = this.data._isWindowsEnvironment;
  }
  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.fileManagerService.updateImageDate(this.imageDate, this.documentIds).subscribe((res) => {
      this.dialogRef.close(res[0].DocumentCreateDate);
    });
  }
}
